import { isStVersionAtLeast, parseStVersion } from './stVersionMet.js'

export default function stMinVersionMet(stCurrent, stMinVersion) {
    return isStVersionAtLeast(parseStVersion(stCurrent), parseStVersion(stMinVersion))
}
